module.exports = flarum.core.compat['Component'];